import React from "react";
import "./PlaceList.css";
import Card from "../../shared/components/UIElements/Card/Card";
import PlaceItem from "./PlaceItem";
import Button from "../../shared/components/FormElements/Button/Button";

const PlaceList = (props) => {
  // console.log('props',props.items)
  if (props.items.length === 0) {
    return (
      <div className="center">
        <Card>
          <h2>No Places Found. Add One?</h2>
          <Button to="/places/new">Share Place</Button>
        </Card>
      </div>
    );
  }
  // console.log(props);
  return (
    <ul className="place-list">
      {props.items.map((place) => {
        return (
          <PlaceItem
            key={place.id}
            id={place.id}
            image={place.image}
            title={place.title}
            description={place.description}
            location={place.location}
            address={place.address}
            creatorId={place.creator}
            onDelete={props.onDeletePlace}
          />
        );
      })}
    </ul>
  );
};

export default PlaceList;
